// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../pages/Home.vue";
import AssortimentPage from "../pages/Assortiment.vue";
import VacaturePagina from "../pages/Vacatures.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/assortiment",
    name: "AssortimentPage",
    component: AssortimentPage,
  },
  {
    path: "/vacatures",
    name: "VacaturesPage",
    component: VacaturePagina,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Altijd naar boven scrollen
    return { top: 0 };
  }
  
});

export default router;
